import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

import {CONFIG} from "../../../app/config";
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {TAction} from "../../../app/enum";
import {LogadoService} from "../../../providers/logado-service";
import {HotspotService} from "../../../providers/hotspot-service";
import {ProfilePagePage} from "../profile-page/profile-page";
import {ListingMenuPage} from "../listing-menu/listing-menu";

@Component({
    selector: 'page-hotspot-mark',
    templateUrl: 'hotspot-mark.html',
    providers: [HotspotService]
})
export class HotspotMarkPage {

    config: any;
    logado: any;
    rootile: any;
    userset: any;

    etapa: number;

    rootspot: any;
    copyspot: any;

    anality: any;

    constructor(public navCtrl: NavController, public navParams: NavParams, public util: Util,
                public logadoService: LogadoService,
                public hotspotService: HotspotService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.rootile = this.navParams.get('rootile');
        this.userset = this.navParams.get('userset'); //#NOUSE

        this.etapa = this.navParams.get('etapa');

        this.rootspot = this.navParams.get('rootspot');
        this.copyspot = this.navParams.get('copyspot');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Marketing', '/hotspot-mark');

        if (this.etapa == 0) this.followeQtde();

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    getTitle() {

        if (this.etapa == 0) return 'Marketing';
        if (this.etapa == 1) return 'Subscribe';
        if (this.etapa == 2) return 'Feedback';

    }

    seguidor() {

        let object = {etapa: 1, rootile: this.rootile, rootspot: this.rootspot, copyspot: this.copyspot, userset: this.userset};
        this.navCtrl.push(HotspotMarkPage, object);

    }

    hotstarMenu() {

        alert('Estastística do Hotstar');

    }

    enqueteMenu() {

        alert('Enquete em desenvolvimento');

    }

    followeQtde() {

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.followe(TAction.acQtde, this.copyspot.Hotspots[0].HotspotID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.anality = data.Followes[0] || {},
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    followeLost() {

        let alignC = {type: 'text', text: '', show: ['Profile', 'ProfileShow'], info: 'FolloweFree', color: ''};
        let alignR = {type: 'bttn', show: 'Liberar', info: '', color: ''};

        let onShow = (show, that, limitPage, reload) => {

            let loading = this.util.loadingDots();
            loading.present();

            this.hotspotService.followe(TAction.acLost, this.copyspot.Hotspots[0].HotspotID)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => that.parseArray(data.Followes),
                    erro => this.util.alertResult(erro, () => that.dismiss())
                );

        };

        let onOkuy = (okey, that, line, click, event) => {

            this.navCtrl.push(ProfilePagePage, {profileID: line.ProfileID});

        };

        let modalshow = this.config.listingForm('Restrito', onShow, onOkuy, null, alignC, alignR, 'CorMenu');
        let objectData = {profile: this.logado.Profile, modalshow: modalshow, tabmenu: false};

        this.navCtrl.push(ListingMenuPage, objectData);

    }

    birthday() {

    }

    dismiss() {

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/hotspot-mark/hotspot-mark.ts